"use client";

import { faPaperPlane } from "@fortawesome/pro-solid-svg-icons";
import { SubmitButton } from "@tosize/ui";
import type { ReactNode } from "react";
import { useFormContext } from "react-hook-form";
import type { ContactCategory, ContactSubject } from "./types/schema";

interface Props {
	category: ContactCategory[];
	subject: ContactSubject[];
	children: ReactNode;
	inverted?: boolean;
}

export function ShowTicketCategorySubject(props: Props) {
	const { category, subject, children, inverted = false } = props;
	const { watch } = useFormContext();
	const categoryValue: unknown = watch("category");
	const subjectValue: unknown = watch("subject");

	const isCategory = typeof categoryValue === "string" ? category.includes(categoryValue) : false;
	const isSubject = typeof subjectValue === "string" ? subject.includes(subjectValue) : false;

	if (inverted) {
		return !(isCategory && isSubject) ? children : null;
	}

	if (!(isCategory && isSubject) || subjectValue === "order_change") {
		return null;
	}

	return <div className="flex flex-col gap-4">{children}</div>;
}

export function Submit({ children }: { children: ReactNode }) {
	const { watch } = useFormContext();
	const categoryValue: unknown = watch("category");
	const subjectValue: unknown = watch("subject");

	if (!(categoryValue && subjectValue) || subjectValue === "order_change") {
		return null;
	}

	return (
		<SubmitButton starticon={faPaperPlane} className="w-full" color="success" size="large">
			{children}
		</SubmitButton>
	);
}
